import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=d74c575c&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=d74c575c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74c575c",
  null
  
)

export default component.exports